module.exports = __webpack_public_path__ + "img/images-2.e75b34e8.jpg";